module.exports = __webpack_public_path__ + "static/media/submit.795aa341.png";